import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Vercel",
  "description": "学习如何在 Vercel 上使用 Turborepo。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Vercel 与 Turborepo 的零配置集成可自动理解你的 monorepo。"
  }, {
    "heading": "",
    "content": "¥Vercel's zero-config integration with Turborepo automatically understands your monorepo."
  }, {
    "heading": "",
    "content": "要在 Vercel 上部署你的 Turborepo，请使用 创建新项目 并导入你的代码。你的项目将预先配置正确的设置以使用 Vercel 远程缓存。"
  }, {
    "heading": "",
    "content": "¥To deploy your Turborepo on Vercel, create a new project and import your code. Your projects will be pre-configured with the correct settings to use the Vercel Remote Cache."
  }, {
    "heading": "",
    "content": "更多有关将 Turborepo 部署到 Vercel 的信息，请访问 访问 Vercel 文档。"
  }, {
    "heading": "",
    "content": "¥For more information about deploying your Turborepo to Vercel, visit the Vercel documentation."
  }],
  "headings": []
};
import __img0 from "./../../../../public/images/docs/turborepo-x-vercel.png";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsx(_components.p, {
      children: "Vercel 与 Turborepo 的零配置集成可自动理解你的 monorepo。"
    }), "\n", _jsx(_components.p, {
      children: "¥Vercel's zero-config integration with Turborepo automatically understands your monorepo."
    }), "\n", _jsxs(_components.p, {
      children: ["要在 Vercel 上部署你的 Turborepo，请使用 ", _jsx(_components.a, {
        href: "https://vercel.com/new",
        children: "创建新项目"
      }), " 并导入你的代码。你的项目将预先配置正确的设置以使用 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel 远程缓存"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To deploy your Turborepo on Vercel, ", _jsx(_components.a, {
        href: "https://vercel.com/new",
        children: "create a new project"
      }), " and import your code. Your projects will be pre-configured with the correct settings to use the ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["更多有关将 Turborepo 部署到 Vercel 的信息，请访问 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/monorepos/turborepo",
        children: "访问 Vercel 文档"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For more information about deploying your Turborepo to Vercel, ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/monorepos/turborepo",
        children: "visit the Vercel documentation"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
